"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const MenuItemTypeCode = {
  DEFAULT: 0,
  DASHBOARD: 1,
  NO_SITE_MAP_VIEW: 2,
  NO_POPUP_MENU: 3,
  NO_LEFT_NAV_MENU: 4,
  PLAN_SELECTOR: 5,
  FINANCIAL_ACTIONABLE: 6,
  SIDEBAR_RIGHT: 7,
  DIRECTORY_NAVIGATION: 8,
  SIDEBAR_LEFT: 9,
  SAML_PROVIDER: 10
};
var _default = exports.default = MenuItemTypeCode;
//# sourceMappingURL=MenuItemTypeCode.js.map